var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgS3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.03601 3.89001V20.11L6.34801 19.372V4.50802L3.03601 3.89001Z",
    fill: "#6484E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.167 0.44397H9.672L9.884 23.606H14.167V0.44397Z",
    fill: "#3260E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.67204 0.44397L6.34804 2.17997V21.778L9.88404 23.606L9.67204 0.44397ZM1.49304 4.50797V19.492L3.03604 20.11V3.88997L1.49304 4.50797Z",
    fill: "#2646A0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.167 23.606V0.44397L17.703 2.21697V21.899L14.167 23.606Z",
    fill: "#507BF7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.703 4.52002V19.38L20.892 20.11V3.89001L17.703 4.52002Z",
    fill: "#2646A0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.892 3.89001V20.11L22.534 19.266V4.64301L20.892 3.89001Z",
    fill: "#3260E5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgS3);
export default __webpack_public_path__ + "static/media/s3.9bd328ed.svg";
export { ForwardRef as ReactComponent };